import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, WritableSignal, signal } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { FormFieldService } from 'src/app/api/form-field.service';
import { Incident, IncidentReport, IncidentsService, IncidentTypes, REPORT_COMPLETE_STEP } from 'src/app/api/incidents.service';
import { LinkableIncidentService } from 'src/app/api/linkable-incident.service';
import { FormField } from '../forms/formDefinition';
import { OnLinkValues } from '../link-report/link-report.component';
import { IncidentModalService } from '../modals/incident-modal.service';

@Component({
    selector: 'app-view-witness-report',
    templateUrl: './view-witness-report.component.html',
    styleUrls: ['./view-witness-report.component.scss'],
    providers: [DialogService],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewWitnessReportComponent implements OnInit, OnDestroy {


  report: WritableSignal<IncidentReport> = signal(this.incidentService.emptyIncidentReport);

  witnessFormFields: WritableSignal<FormField[]> = signal([])
  incidentReportType: WritableSignal<IncidentTypes> = signal(IncidentTypes.Unknown);
  incidents: WritableSignal<Incident[]> = signal([]);
  incomplete = signal(false);
  modalRef: DynamicDialogRef | undefined
  modalSubscription: Subscription | undefined

  constructor(
    private route: ActivatedRoute,
    private incidentService: IncidentsService,
    private formFieldService: FormFieldService,
    private incidentModalService: IncidentModalService,
    private dialogService: DialogService,
    private router: Router,
    private linkableIncidentService: LinkableIncidentService
  ) {
    
   }
 
   ngOnDestroy(): void {
    if (this.modalRef) {
      if (this.modalSubscription) {
        this.modalSubscription.unsubscribe()
      }
      this.modalRef.close()
    }
  }



  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const idString = params.get("id")

      if (idString) {
        const id = Number.parseInt(idString)
        this.loadIncident(id)
      }
    })


    this.linkableIncidentService.getIncidents().subscribe(incidents => {
      this.incidents.set(incidents);
    })
  
  }

  loadIncident(id: number) {
    this.incidentService.getIncidentReport(id).subscribe(incident => {
      if (incident.incident.currentStepId == REPORT_COMPLETE_STEP) {
      this.report.set( incident)
      this.formFieldService.getIncidentReportFields(this.report().incident.typeId, this.report().incident.dateCreated).subscribe(fields => {
        this.witnessFormFields.set(fields);
      });
    } else {
      this.incomplete.set(true);
    }
    })
  }

  linkIncidentReport(incident: Incident) {
    this.modalRef = this.incidentModalService.showLinkReportModal(this.dialogService, this.incidents(), incident.workItemId)
    
    this.modalSubscription = this.modalRef.onClose.subscribe(
      (result: OnLinkValues | undefined) => {
        this.modalRef = undefined;
        this.modalSubscription = undefined;

        if (result == OnLinkValues.LinkSuccess) {
       
        }
  
        if (result == OnLinkValues.CreateIncident) {
          this.router.navigate(['incidents', 'create'], {state: {incidentReport: incident}})
        }
      }
    )
  
    
  }

  

}
